import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LeadCapture from "./pages/LeadCapture";
import QuestionFlow from "./pages/QuestionFlow";
import PromptsPreview from "./pages/PromptsPreview";
import Success from "./pages/Success";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LeadCapture />} />
          <Route path="/embed" element={<LeadCapture />} />
          <Route path="/try" element={<QuestionFlow />} />
          <Route path="/prompts" element={<PromptsPreview />} />
          <Route path="/success" element={<Success />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
